/* eslint-disable eqeqeq */
// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable array-callback-return */
import React from 'react';
import { Table, Button, Spin, Tooltip, Modal, Input, Tag } from 'antd';
// eslint-disable-next-line import/no-extraneous-dependencies
import { PrinterOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { GLOBAL_TABLE_SIZE } from 'global_config/constant-global';

import {
	fetchRequestSpecimenToProcess,
	checkinSpecimen,
	rejectSpecimenStatus,
} from 'services/phlebo/specimenTracking';
import printBarcodeLabel from 'services/phlebo/barcodeLabel';
import HttpCodeMessage from 'shared_components/message_http_status';
import { messagePrompts, buttonNames } from './settings';
import Message from 'shared_components/message';

import './specimen.css';
import { CheckSquareOutlined, FlagOutlined, StopOutlined } from '@ant-design/icons';

class SpecimenList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			requestID: null,
			examRequests: [],
			loadingIndex: [],
			isFetchingData: false,
			rejectReason: '',
			modalVisible: false,
			modalParams: {},
			modalRejectVisible: '',
			modalRemarks: '',
		};

		this.columns = [
			// {
			// 	title: 'EXAM NO',
			// 	key: 'index',
			// 	render: (value, row, index) => {
			// 		return(index+1)
			// 	},
			// 	width: 120
			// },
			{
				title: 'SECTION',
				dataIndex: 'sectionName',
				width: 100,
			},
			{
				title: 'SPECIMEN',
				dataIndex: 'specimenName',
				width: 100,
			},
			{
				title: 'SAMPLE ID',
				dataIndex: 'sampleSpecimenID',
				width: 100,
			},
			{
				title: '',
				dataIndex: 'priority',
				width: 70,
				render: (text, record) => (
					<div>{record.priority === 1 ? <span>STAT</span> : <span>Routine</span>}</div>
				),
			},
			{
				title: 'EXTRACTED BY',
				dataIndex: 'extractedBy',
				width: 120,
			},
			{
				title: 'DATE EXTRACTED',
				dataIndex: 'dateExtracted',
				width: 100,
			},
			{
				title: 'DATE REJECTED',
				dataIndex: 'dateRejected',
				width: 100,
			},
			// {
			// 	title: 'STATUS',
			// 	dataIndex: 'phlebo_status_col',
			// 	width: 70,
			// 	render: (value, row) => {
			// 		let buttonColor;

			// 		// Determine color based on statusID
			// 		if (row.statusID >= 0 && row.statusID <= 3) {
			// 			buttonColor = 'green';
			// 		} else if (row.statusID >= 5 && row.statusID <= 8) {
			// 			buttonColor = 'yellow';
			// 		} else if (row.statusID >= 9 && row.statusID <= 10) {
			// 			buttonColor = 'red';
			// 		} else if (row.statusID === 4) {
			// 			buttonColor = 'orange';
			// 		} else {
			// 			// Default color if statusID doesn't match any range
			// 			buttonColor = '8A73F9';
			// 		}

			// 		return (
			// 			<Tooltip title={row.status}>
			// 				<Button
			// 					icon={<FlagOutlined />}
			// 					style={{
			// 						marginLeft: 10,
			// 						borderColor: 'transparent',
			// 						color: buttonColor,
			// 					}}
			// 					onClick={() => this.handleOnClickStatus(row.remarks)}
			// 				/>
			// 			</Tooltip>
			// 		);
			// 	},
			// },
			{
				title: 'STATUS',
				dataIndex: 'phlebo_status_col',
				width: 70,
				render: (text, record) => (
					<Tag
						style={{
							cursor: 'pointer', // Add cursor pointer for better UX
						}}
						onClick={() => this.handleOnClickStatus(record.remarks)}
						color={this.getStatusColor(record.statusID)}
					>
						{record.status.toUpperCase()}
					</Tag>
				),
			},
			{
				title: 'ACTION',
				dataIndex: 'phlebo_action_col',
				width: 180,
				render: (value, row, index) => {
					console.log('🚀 ~ SpecimenList ~ constructor ~ row:', row);
					const { loadingIndex } = this.state;
					const isLoading = loadingIndex.findIndex(i => i === index) !== -1;
					const isExtracted = !!row.sampleSpecimenID; // If sampleSpecimenID exists, specimen is already extracted

					return (
						<div>
							<Tooltip title="Reject">
								<Button
									style={{
										marginLeft: 10,
										borderColor: 'transparent',
										color: '#8A73F9',
										background: '#f5f5f5',
									}}
									onClick={() =>
										this.onClickReject(
											row.sectionID,
											row.specimenID,
											index,
											row.sampleSpecimenID,
											row,
											row.remarks,
										)
									}
									loading={isLoading}
									disabled={isExtracted || row.statusID === 9}
									icon={<StopOutlined />}
								>
									{/* {row.sampleSpecimenID ? buttonNames.extracted : buttonNames.extract} */}
								</Button>
							</Tooltip>
							<Tooltip title="Extract">
								<Button
									style={{
										marginLeft: 10,
										borderColor: 'transparent',
										color: '#8A73F9',
										background: '#f5f5f5',
									}}
									onClick={() => this.onClickExtract(row.sectionID, row.specimenID, index)}
									loading={isLoading}
									disabled={isExtracted}
									icon={<CheckSquareOutlined />}
								>
									{/* {row.sampleSpecimenID ? buttonNames.extracted : buttonNames.reject} */}
								</Button>
							</Tooltip>
							<Tooltip title="Print">
								<Button
									style={{
										marginLeft: 10,
										borderColor: 'transparent',
										color: '#8A73F9',
										background: '#f5f5f5',
									}}
									onClick={() => this.handlePrint(row.sampleSpecimenID)}
									icon={<PrinterOutlined />}
									disabled={!row.sampleSpecimenID}
								/>
							</Tooltip>
						</div>
					);
				},
			},
		];
	}

	componentDidMount() {
		// const { patientInfo } = this.props;
		// this.setState({ isFetchingData: true }, async () => {
		// 	const patientSpecimens = await fetchRequestSpecimenToProcess(patientInfo.requestID);
		// 	this.setState({
		// 		requestID: patientSpecimens.requestID,
		// 		examRequests: patientSpecimens.examRequests,
		// 		isFetchingData: false
		// 	});
		// });
	}

	componentDidUpdate(prevProps) {
		const { patientSpecimens } = this.props;

		if (patientSpecimens) {
			if (prevProps.patientSpecimens.requestID !== patientSpecimens.requestID) {
				this.setState({ examRequests: patientSpecimens.examRequests });
			}
		}
	}

	onClickExtract = (sectionID, specimenID, index) => {
		const { patientInfo, patientSpecimens } = this.props;
		const { requestID } = patientSpecimens;
		const { userID } = JSON.parse(sessionStorage.getItem('LOGGEDIN_USER_DATA'));

		this.setState(
			state => {
				return { loadingIndex: state.loadingIndex.concat([index]) };
			},
			async () => {
				const { examRequests } = this.state;
				let examRequestClone = JSON.parse(JSON.stringify(examRequests));

				const saveExtraction = await checkinSpecimen({
					'p_request_header_id' : requestID,
					'p_lab_section_id' : sectionID,
					'p_lab_specimen_id' : specimenID,
					'p_login_user_id' : userID,
				});

				if (saveExtraction.statusCode === 200 || saveExtraction.success) {
					HttpCodeMessage({
						status: saveExtraction.statusCode,
						message: `${messagePrompts.successExtraction} ${saveExtraction.data.sampleSpecimenID}`,
					});

					const patientSpecimens = await fetchRequestSpecimenToProcess(patientInfo.requestID);

					examRequestClone = patientSpecimens.examRequests;

					//temporary commented out printing after extraction
					//this.handlePrint(saveExtraction.data.sampleSpecimenID);
				}

				// else {
				// 	HttpCodeMessage({
				// 		status: saveExtraction.status,
				// 		message: messagePrompts.commonErrorMessage,
				// 	});
				// }

				this.setState(state => {
					return {
						loadingIndex: state.loadingIndex.filter(i => i !== index),
						examRequests: examRequestClone,
					};
				});
			},
		);
	};

	getStatusColor(status) {
		if (status === 0) {
			return '#C65911';
		} else if (status === 1) {
			return '#833C0C';
		} else if (status ===2) {
			return '#BF8F00';
		} else if (status === 3) {
			return '#00B050';
		} else if (status === 4) {
			return '#FC1C04';
		} else if (status === 5) {
			return '#305496';
		} else if (status === 6) {
			return '#002060';
		} else if (status === 7) {
			return '#CC66FF';
		} else if (status === 8) {
			return '#00B050';
		} else if (status === 9) {
			return '#FC1C04';
		} else {
			return '#8A73F9'; // default color if status doesn't match any range
		}
	}

	handleOk = async () => {
		const { patientInfo, patientSpecimens } = this.props;
		const { requestID } = patientSpecimens;
		const { userID } = JSON.parse(sessionStorage.getItem('LOGGEDIN_USER_DATA'));
		const { patientID } = patientInfo;
		const { sectionID, specimenID, index, sampleSpecimenID, row } = this.state.modalParams;
		const { rejectReason } = this.state;

		this.setState({ modalVisible: false, loadingIndex: this.state.loadingIndex.concat([index]) });

		const isSampleSpecimen = !!sampleSpecimenID;

		const updateSpecimen = await rejectSpecimenStatus({
			p_patient_demographics_id : patientID,
			p_request_header_id : requestID,
			p_sample_id: isSampleSpecimen ? sampleSpecimenID : '',
			p_lab_section_id: isSampleSpecimen ? 0 : sectionID,
			p_lab_specimen_id: isSampleSpecimen ? 0 : specimenID,
			p_specimen_location: '',
			p_remarks: rejectReason,
			p_specimenstatusid: 9, // constant
			p_login_user_id: userID,
		});

		console.log('updateSpecimen', updateSpecimen);

		if (updateSpecimen.status === 200 || updateSpecimen.length > 0) {
			HttpCodeMessage({
				status: updateSpecimen.status,
				message: `${messagePrompts.successReject}`,
			});

			this.setState({ rejectReason: '' });

			const patientSpecimens = await fetchRequestSpecimenToProcess(patientInfo.requestID);
			const examRequestClone = patientSpecimens.examRequests;

			this.setState({
				loadingIndex: this.state.loadingIndex.filter(i => i !== index),
				examRequests: examRequestClone,
			});
		}
		// else {
		//   HttpCodeMessage({
		// 	status: updateSpecimen.status,
		// 	message: messagePrompts.commonErrorMessage,
		//   });
		// }
	};

	handleCancel = () => {
		this.setState({ modalVisible: false });
	};

	handleOnClickStatus = remarks => {
		if (remarks != null) {
			if (remarks.length > 0) {
				this.setState({ modalRejectVisible: true, modalRemarks: remarks });
			}
		}
	};

	handleOkCancelReject = () => {
		this.setState({ modalRejectVisible: false });
		this.setState({ rejectReason: '' });
	};

	onClickReject = (sectionID, specimenID, index, sampleSpecimenID, row, remarks) => {
		// const { patientInfo, patientSpecimens } = this.props;
		// // const { requestID } = patientSpecimens;
		// // const { userID } = JSON.parse(sessionStorage.getItem('LOGGEDIN_USER_DATA'));
		// // const { patientID } = patientInfo;

		this.setState({ rejectReason: '' });

		if (remarks != null) {
			if (remarks.length > 0) {
				this.setState({ modalRejectVisible: true, modalRemarks: remarks });
			} else {
				this.setState({
					modalVisible: true,
					modalParams: {
						sectionID,
						specimenID,
						index,
						sampleSpecimenID,
					},
				});
			}
		} else {
			this.setState({
				modalVisible: true,
				modalParams: {
					sectionID,
					specimenID,
					index,
					sampleSpecimenID,
				},
			});
		}
	};

	handlePrint = async specimenID => {
		const printBarcode = await printBarcodeLabel(specimenID);
		Message.success({
			message: printBarcode,
			setTimeout: 5,
		});
	};

	render() {
		const { examRequests, isFetchingData } = this.state;
		const { visible, onCancel } = this.props;
		const { rejectReason, modalVisible, modalRejectVisible, modalRemarks } = this.state;

		return (
			<div className="phlebotable-container">
				<Spin spinning={isFetchingData}>
					<Table
						columns={this.columns}
						expandedRowRender={record => (
							<div style={{ padding: '20px' }}>{record.exams.join(', ')}</div>
						)}
						dataSource={examRequests}
						rowKey={record => `${record.sectionCode}-${record.specimenID}`}
						size={GLOBAL_TABLE_SIZE}
						pagination={false}
						// scroll={{ y: 300 }}
					/>
				</Spin>
				<Modal
					title="Reject Reason"
					visible={modalVisible}
					onCancel={onCancel}
					footer={[
						<Button key="cancel" onClick={this.handleCancel}>
							Cancel
						</Button>,
						<Button key="ok" type="primary" onClick={this.handleOk}>
							OK
						</Button>,
					]}
				>
					<Input.TextArea
						placeholder="Enter reject reason..."
						value={rejectReason}
						onChange={e => this.setState({ rejectReason: e.target.value })}
						rows={4}
					/>
				</Modal>
				<Modal
					title="Reject Reason"
					visible={modalRejectVisible}
					onOk={this.handleOkCancelReject}
					onCancel={this.handleOkCancelReject}
				>
					<p>{modalRemarks}</p>
				</Modal>
			</div>
		);
	}
}

SpecimenList.propTypes = {
	patientInfo: PropTypes.object,
	patientSpecimens: PropTypes.object,
};

SpecimenList.defaultProps = {
	patientInfo() {
		return null;
	},
	patientSpecimens: { requestID: null },
};

export default SpecimenList;
